import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

interface SupportChannelCardProps {
  channel: {
    icon: React.ReactNode;
    title: string;
    description: string;
    availability: string;
    response: string;
    color: string;
  };
  index: number;
}

const SupportChannelCard: React.FC<SupportChannelCardProps> = ({
  channel,
  index,
}) => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const cardLabels =
    labels.menuPages?.buyCar?.customerServiceSection?.supportChannelCard || {};
  const availabilityLabel = cardLabels.availabilityLabel ?? (language === "en" ? "Availability:" : "Tillgänglighet:");
  const responseTimeLabel = cardLabels.responseTimeLabel ?? (language === "en" ? "Response time:" : "Svarstid:");
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300"
    >
      <div
        className={`inline-flex p-4 rounded-full bg-gradient-to-br ${channel.color} text-white mb-6`}
      >
        {channel.icon}
      </div>

      <h3 className="text-xl font-bold text-gray-900 mb-4">{channel.title}</h3>

      <p className="text-gray-600 mb-6">{channel.description}</p>

      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">
            {availabilityLabel}
          </span>
          <span className="text-sm font-semibold text-gray-900">
            {channel.availability}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">
            {responseTimeLabel}
          </span>
          <span className="text-sm font-semibold text-green-600">
            {channel.response}
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default SupportChannelCard;
